module.exports = __webpack_public_path__ + "img/delete.eee0abd9.svg";